// VAPT: "this login must change its password" flags, kept in memory only.
//
// These used to live in localStorage as "forceReset" / "redirectOnLogin". The backend now
// remembers them in an HttpOnly cookie (pwd-reset-pending) that it sets only at a password or
// 2FA login, so the UI holds them in memory:
//   - signin / 2FA login fill them from the login response, in the same tab;
//   - loadByUsername fills them on every page load and new tab, from the server's answer;
//   - a successful password change clears them (the backend also expires the cookie).
// Memory is per tab and gone on reload, which is fine: loadByUsername refills it.
//   forceReset      = password expired
//   redirectOnLogin = password was reset by an admin

let flags = { forceReset: false, redirectOnLogin: false };

export const setPasswordResetFlags = (forceReset, redirectOnLogin) => {
  flags = { forceReset: !!forceReset, redirectOnLogin: !!redirectOnLogin };
  if (flags.forceReset || flags.redirectOnLogin) {
    console.warn("[pwd-reset] password change required", flags);
  }
};

export const getPasswordResetFlags = () => flags;

export const isPasswordResetPending = () => flags.forceReset || flags.redirectOnLogin;

export const clearPasswordResetFlags = () => {
  flags = { forceReset: false, redirectOnLogin: false };
};
